import { AulaEditor } from '@ublend-npm/aula-editor';
import withAnalytics from './withAnalytics';
import withErrorBoundary from '../ErrorBoundary/ErrorBoundary';

const AulaEditorWithAnalytics = withErrorBoundary(withAnalytics(AulaEditor), {
  ignore: true,
});

export default AulaEditorWithAnalytics;
